const defaultState = null;

export const GET_ROLE_PERMISSION_CONFIG = "GET_ROLE_PERMISSION_CONFIG";
export const GET_ROLE_PERMISSION_CONFIG_ERROR = "GET_ROLE_PERMISSION_CONFIG_ERROR";
export const rolePermissionConfigReducer = (state = defaultState, action: any) => {
  const { type } = action;
  if (type === GET_ROLE_PERMISSION_CONFIG) return action.data;
  if (type === GET_ROLE_PERMISSION_CONFIG_ERROR) return defaultState;
  return state;
};
